define(function(require, exports, module) {
    'use strict';
    var RecentlyPlayedGamesStore = require('stores/recently-played-games/recently-played-games.store');

    module.exports = new RecentlyPlayedGamesStore();
});